<script setup>
import { RouterLink } from 'vue-router';
import ClubsLogo from '@/images/clubs-logo.svg';
import WusaLogo from '@/images/wusa-logo.svg';
import RESOURCES from '@/config/resourceUrls';
const props = defineProps({
    appName: {
        type: String,
        default: 'Wusa Clubs'
    },
    provideName: {
        type: String,
        default: 'WUSA'
    },
    logo: {
        type: String,
        default: ClubsLogo
    },
    providerLogo: {
        type: String,
        default: WusaLogo
    }
});
</script>

<template>
    <div class="bg-wusa-navy-primary text-white px-4 py-5 md:px-5 lg:px-5" data-testid="footer">
        <div class="bg-wusa-navy-primary">
            <div class="grid grid-cols-1 md:grid-cols-12 gap-4 container">
                <div class="col-span-12 md:col-span-12 lg:col-span-2 flex flex-wrap justify-start items-start mb-3 md:mb-0">
                    <img :src="logo" :alt="appName" />
                </div>
                <div class="col-span-12 md:col-span-6 lg:col-span-2 text-gray-200" data-testid="footer-first-menu">
                    <div class="font-bold py-2">Clubs</div>

                    <router-link :to="{name: 'find-a-club'}" class="py-2 block cursor-pointer">
                        Clubs Directory
                    </router-link>

                    <router-link :to="{name: 'club-new'}" class="py-2 block cursor-pointer">
                        New Club Application
                    </router-link>


                    <router-link :to="{name: 'faq'}" class="py-2 block cursor-pointer">
                        Frequently Asked Questions
                    </router-link>

                </div>
                <div class="col-span-12 md:col-span-6 lg:col-span-3 text-gray-200 my-4 md:my-0" data-testid="footer-second-menu">
                    <div class="font-bold py-2">Resources</div>

                   <router-link :to="{name: 'event-meeting-spaces'}" class="py-2 block cursor-pointer">
                        Event & Meeting Spaces
                    </router-link>


                   <router-link :to="{name: 'event-planning'}" class="py-2 block cursor-pointer">
                        Event Planning & Assistance
                    </router-link>

                   <router-link :to="{name: 'financial-planning'}" class="py-2 block cursor-pointer">
                        Financial Advising & Support
                    </router-link>

                   <router-link :to="{name: 'it-support'}" class="py-2 block cursor-pointer">
                        IT Support
                    </router-link>

                   <router-link :to="{name: 'marketing-support'}" class="py-2 block cursor-pointer">
                        Marketing Support
                    </router-link>

                    <router-link :to="{name: 'free-storage-space'}" class="py-2 block cursor-pointer">
                        Storage Space
                    </router-link>

                </div>
                <div class="col-span-12 md:col-span-6 lg:col-span-2 text-gray-200 my-4 md:my-0" data-testid="footer-third-menu">
                    <div class="font-bold py-2">Terms & Policies</div>

                    <a :href="RESOURCES.WUSA_PRIVACY_POLICY" target="_blank" class="py-2 block cursor-pointer">
                        Privacy Policy
                    </a>

                    <a :href="RESOURCES.WUSA_TERMS_AND_CONDITIONS" target="_blank" class="py-2 block cursor-pointer">
                        Terms and Conditions
                    </a>

                </div>
                <div class="col-span-12 md:col-span-6 lg:col-span-3">
                    <div class="max-w-xs">
                        <address class="leading-loose">
                            Clubs Community Centre<br />
                            200 University Avenue West<br />
                            Student Life Centre, Room 2139<br />
                            Waterloo, ON, Canada<br />N2L 3G1
                        </address>
                    </div>
                    <div class="py-2">
                        <i class="fa fa-inbox p-1 mr-1"></i><a :href="`mailto:${RESOURCES.CLUBS_ASSISTANT_EMAIL}`" class="text-white">{{ RESOURCES.CLUBS_ASSISTANT_EMAIL }}</a>
                    </div>
                    <div class="block md:hidden lg:block">
                        <div class="py-2">Supported by</div>
                        <a href="https://wusa.ca" target="_blank">
                            <img :src="providerLogo" :alt="provideName" />
                        </a>
                    </div>
                </div>
                <div class="hidden md:block lg:hidden col-span-12 md:col-span-6 lg:col-span-12">
                    <div class="py-2">Supported by</div>
                    <a href="https://wusa.ca" target="_blank">
                        <img :src="providerLogo" :alt="provideName" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
address {
    font-style: normal;
}

.bg-wusa-navy-primary {
    background-color: var(--p-wusa-navy-primary);
}

.text-white {
    color: var(--p-wusa-white);
}
</style>
